import useSWR from "swr";

export interface EventType {
  id: string;
  name: string;
}

export function useGetEventTypes(spaceId?: string): { data?: EventType[] } {
  const response = useSWR(
    spaceId ? `/api/v2/spaces/${spaceId}/event_types` : null
  );

  return { data: response.data?.map(toEventTypes) };
}

function toEventTypes(data: any): EventType | undefined {
  if (data) {
    return {
      id: data.id,
      name: data.name,
    };
  }
}
